// At-risk and LARDO helpers shared by the admin and teacher dashboards.

export const JHS_GRADES = [7, 8, 9, 10];
export const SHS_GRADES = [11, 12];

// 7 from "Grade 7", "7", 7, "G7"…
export function gradeNumber(gradeLevel) {
  const match = String(gradeLevel ?? '').match(/\d+/);
  return match ? Number(match[0]) : null;
}

export function initials(name) {
  return (
    String(name || '')
      .split(/\s+/)
      .filter((w) => /^[a-z]/i.test(w))
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join('') || '?'
  );
}

export function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleDateString('en-PH', { year: 'numeric', month: 'short', day: 'numeric' });
}

// Grade bands used on the at-risk list (the list only holds grades ≤ 80).
export function riskBand(grade) {
  const n = Number(grade);
  if (grade == null || Number.isNaN(n)) return { label: 'No grade', variant: 'secondary' };
  if (n <= 75) return { label: 'At risk', variant: 'red' };
  if (n <= 80) return { label: 'Watch', variant: 'amber' };
  return { label: 'Safe', variant: 'green' };
}

// LARDO remarks start with the severity: "CRITICAL: …", "EARLY WARNING: …".
export function lardoSeverity(remarks) {
  const r = String(remarks || '');
  if (r.startsWith('CRITICAL')) {
    return { label: 'Critical', variant: 'red', icon: 'mdi-alert-octagon-outline' };
  }
  if (r.startsWith('EARLY WARNING')) {
    return { label: 'Early warning', variant: 'amber', icon: 'mdi-alert-outline' };
  }
  return { label: 'Notice', variant: 'blue', icon: 'mdi-information-outline' };
}

// "CRITICAL: finding … Recommendation: next step" → { finding, recommendation }
export function lardoRemarkParts(remarks) {
  const r = String(remarks || '');
  const colon = r.indexOf(':');
  const body = colon > -1 ? r.slice(colon + 1).trim() : r;
  const at = body.search(/Recommendation:/i);
  if (at === -1) return { finding: body, recommendation: '' };
  return {
    finding: body.slice(0, at).trim(),
    recommendation: body.slice(at + 'Recommendation:'.length).trim(),
  };
}

// Teacher dashboard bands for a transmuted grade (its list holds ≤ 80).
export function gradeRisk(grade) {
  const n = Number(grade);
  if (grade == null || Number.isNaN(n)) return { label: 'N/A', variant: 'secondary' };
  if (n <= 70) return { label: 'High', variant: 'red' };
  if (n <= 75) return { label: 'Moderate', variant: 'amber' };
  if (n <= 80) return { label: 'Passable', variant: 'amber' };
  return { label: 'Good', variant: 'green' };
}
